/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Tab_TrackInputs */



/**
* | output |
* | --- |
* | "Track Operations" |
*
* @param {Event_Group_Options_Tab_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_tab_track = /** @type {((inputs?: Event_Group_Options_Tab_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Tab_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Opérations de piste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gleisbetrieb")
	if (locale === "it") return /** @type {LocalizedString} */ ("Operazioni di tracciamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Эксплуатация путей")
	if (locale === "es") return /** @type {LocalizedString} */ ("Operaciones de pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("轨道运营")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックオペレーション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक संचालन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Operações de rastreamento")
	return /** @type {LocalizedString} */ ("Track Operations")
});